import styled from '@emotion/styled';
import { colors, fonts, layout } from './theme';

const Root = styled.section`
  background: ${colors.baselineWhite};
  padding: 0 0 clamp(56px, 8vw, 96px);
`;

const Inner = styled.div`
  max-width: ${layout.maxWidth};
  margin: 0 auto;
  padding: 0 clamp(20px, 4vw, 32px);
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: clamp(32px, 4vw, 56px);

  @media (min-width: 800px) {
    grid-template-columns: 1fr 1fr;
    align-items: center;
  }
`;

const Eyebrow = styled.p`
  font-family: ${fonts.mono};
  font-size: 13px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: ${colors.textMuted};
  margin: 0 0 16px;
`;

const Headline = styled.h2`
  font-family: ${fonts.sans};
  font-size: clamp(32px, 3.8vw, 48px);
  line-height: 1.15;
  font-weight: 400;
  max-width: 18ch;
  color: ${colors.coreBlue};
  margin: 0 0 20px;
`;

const HeadlineAccent = styled.span`
  font-family: ${fonts.mono};
  color: ${colors.coreBlueDark};
`;

const Intro = styled.p`
  font-family: ${fonts.sans};
  font-size: 19px;
  line-height: 1.5;
  color: ${colors.textSecondary};
  max-width: 52ch;
  margin: 0 0 24px;
`;

const Checklist = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  max-width: 52ch;
`;

const ChecklistItem = styled.li`
  display: flex;
  gap: 10px;
  font-family: ${fonts.sans};
  font-size: 17px;
  line-height: 1.45;
  color: ${colors.coreBlue};
  padding: 5px 0;

  &::before {
    content: '\\2713';
    color: ${colors.coreBlueDark};
    flex-shrink: 0;
  }
`;

const Media = styled.video`
  display: block;
  width: 100%;
  aspect-ratio: 16 / 9;
  object-fit: cover;
  border-radius: 8px;
  border: 1px solid ${colors.borderSubtle};
`;

const Caption = styled.p`
  font-family: ${fonts.sans};
  font-size: 15px;
  line-height: 1.5;
  color: ${colors.textSecondary};
  max-width: 46ch;
  margin: 14px 0 0;
`;

const bullets = [
  "Import from a Publisher's social channels in one click",
  'Every clip matched to the pages where it earns attention',
  'Open up new video slots for programmatic and direct demand',
];

export default function PublisherContentSection() {
  return (
    <Root>
      <Inner id="import">
        <Grid>
          <div>
            <Eyebrow>Publisher content</Eyebrow>
            <Headline>
              import <HeadlineAccent>directly</HeadlineAccent> from social
            </Headline>
            <Intro>
              Pull a Publisher&apos;s own YouTube, TikTok and Instagram videos into the stream in
              one step and run it across their site as contextual inventory. Content that already
              earned attention on social becomes video supply that lifts both programmatic and
              direct advertising yields.
            </Intro>
            <Checklist>
              {bullets.map((bullet) => (
                <ChecklistItem key={bullet}>{bullet}</ChecklistItem>
              ))}
            </Checklist>
          </div>
          <div>
            <Media autoPlay loop muted playsInline preload="auto">
              <source src="/v2/marketing-video-lady-gaga.mp4" type="video/mp4" />
            </Media>
            <Caption>
              Import editorial video from social - landscape or vertical - matched against the
              most relevant Publisher placements.
            </Caption>
          </div>
        </Grid>
      </Inner>
    </Root>
  );
}
